import { APP_ROUTES, useAppDispatch } from "@/utils";
import { useMessagedAsync } from "@payping/web-components";
import { bnplConsumerGetProfile } from "@payping/redux/actions";
import { FC, ReactNode } from "react";
import { useMatch } from "react-router";
import { clsx } from "clsx";
import Loading from "../loading";

const HomeWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const match = useMatch(APP_ROUTES.home.orderDetail.url);

  const dispatch = useAppDispatch();
  const { loading, error } = useMessagedAsync(() => dispatch(bnplConsumerGetProfile()), [dispatch], {
    success: false,
    error: true,
  });

  if (loading || error) {
    return <Loading />;
  }
  return (
    <>
      <div
        className={clsx([
          {
            "tw:h-full": !!match,
          },
        ])}
      >
        {children}
      </div>
    </>
  );
};

export default HomeWrapper;
